<template>
  <a-modal
      title="设置标签"
      :width="960"
      :visible="visible"
      :maskClosable="false"
      @cancel="cancel"
      :destroyOnClose="true"
      :confirmLoading="loading"
      okText="确定"
      @ok="ok">
    <a-form-model :model="setForm" ref="setForm" class="exi_form item_100"
                  :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ span: 24 }">
      <a-row :gutter="20"
             type="flex"
             align="middle">
        <a-form-model-item label="专家姓名">
         <span v-for="name in expertNames" style="padding: 3px">
               <a-tag color="green">{{ name }}</a-tag>
              </span>
        </a-form-model-item>
        <a-form-model-item label="标签名称">
          <a-radio-group v-model="setForm.tagId">
            <a-radio-button v-for="item in tagList" :value="item.id"><b :style="'color:'+item.tagColor">{{
                item.tagName
              }}</b></a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import qs from 'qs'
import { GetAllTagList } from '@/epp/expertmain/experttag/util/TagUtil'
import { GetExpertNameByIds } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

export default {
  name: 'TagSetModal',
  components: {},
  created () {
  },
  data () {
    return {
      rules: [],
      visible: false,
      loading: false,
      expertId: '',
      expertNames: [],
      setForm: { tagId: undefined },
      tagList: [],
    }
  },
  methods: {
    onStartLoadData (expertId, ids) {
      this.visible = true
      this.expertId = expertId
      this.checkedList = ids && ids.split(',') || []
      //获取标签列表
      this.getAllTagList()
      //获取专家名称
      this.getExpertName()
    },
    cancel () {
      this.visible = false
    },
    ok () {
      const that = this
      if (that.checkedList.length === 0) {
        that.$error({ content: '请选择需要配置的标签！' })
        return
      }
      that.post(that.checkedList.join(','))
    },
    post (tagIds) {
      var data = {}
      data.tagIds = tagIds
      data.expertId = this.expertId
      let url = '/api/1/expertmain/expert_tag/addTagExpert'
      this.loading = true
      this.$http.post(url, qs.stringify(data)).then(resp => {
        if (resp.code !== 200) {
          return false
        }
        this.$message.success('设置成功')
        this.$emit('success')
      }).finally(() => {
        this.loading = false
        this.visible = false
      })
    },
    async getExpertName () {
      try {
        let res = await GetExpertNameByIds({ ids: this.expertId })
        if (res.code !== 200) {
          return false
        }
        this.expertNames = res.result
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async getAllTagList () {
      try {
        this.tagList = await GetAllTagList()
      } catch (e) {
        this.$message.error(e.message)
      }
    },
  }
}
</script>

<style scoped>

</style>
